import {useContext, useEffect} from "react";
import {GateContext} from "../../tools/contexts/GateContext";
import LoadingScreen from "../LoadingScreen";
import servicesRoute from "../../tools/servicesRoute";
import {useNavigate} from "react-router-dom";

const ForeignerAuthGate = () => {
    const navigate=useNavigate();
    const {
        id,
        serviceType,
        returnUrl,
        loading,
        handleLoading,
        handleGetPlatformLink,
        code,
        ticketUuid,
        handlePlatformGuard
    } = useContext(GateContext);
    useEffect(() => {
        if (code) {
            const params={
                "code":code,
                "platform_hash_id":id,
                "service_type":serviceType,
                "post_token":sessionStorage.getItem('ticket_uuid'),
            }
            handleLoading(true)
            handlePlatformGuard(params,(data)=>{
                sessionStorage.setItem('token', data.access_token);
                sessionStorage.setItem('platformUser', JSON.stringify(data.platform_user));
                sessionStorage.setItem('service_type', serviceType);

                navigate(servicesRoute[serviceType].path, {
                    state: {
                        access_token: data.access_token,
                        platform: data.client_name,
                        platform_user: data.platform_user,
                        mobile: data.platform_user.phone_number,
                        defaultService: serviceType,
                    }, replace: true
                })
            })
        } else {
            if(ticketUuid){
                handleGeneratePlatformLink();
            }else {
                navigate('/failed',{
                  state:{
                      message:'خطای سرویس ( پارامتر های ورودی را بررسی کنید)'
                  }
                })
            }

        }
    }, []);
    const handleGeneratePlatformLink=()=>{
        localStorage.clear();
        sessionStorage.clear();
        if (id) {
            sessionStorage.setItem('id', id);
        }
        if (ticketUuid) {
            sessionStorage.setItem('ticket_uuid', ticketUuid);
        }
        if (returnUrl) {
            sessionStorage.setItem('return_url', returnUrl);
        }
        handleLoading(true);
        const params = {
            "post_token": ticketUuid,
            "service_type": serviceType,
            "platform_hash_id": id,
        }

        handleGetPlatformLink(params);
    }
    if(loading){
        return <LoadingScreen/>
    }
    return <></>
}
export default ForeignerAuthGate;